const state = {
  host: '',
  sqlSaida: '',
  sqlUnidades: '',
  sqlItemSaida: '',
  sqlProducao: '',
  sqlItemProducao: '',
  idEstoqueEntradaProducao: '1',
  idColaborador: '1',
  configuracoes: [
    { idConfig: 1, description: 'Modelo coleta produção requisição', value: false },
    { idConfig: 2, description: 'Permitir código de barras repetido', value: false },
    { idConfig: 3, description: 'Permitir quantidade divergente', value: false },
    { idConfig: 4, description: 'Validar código de barras com código produto', value: false },
    { idConfig: 5, description: 'Validar código de barras com unidade produto', value: false },
  ],
  configLayout: [
    { idConfig: 1, description: 'Cor de fundo ao ler código', value: false },
  ],
  rules: {
    required: value => !!value || 'Campo obrigatório',
    cep: value => value && value.length === 8 || 'CEP inválido',
    zeroOrGreater: value => value >= 0 || 'Valor inválido',
    greaterThanZero: value => value > 0 || 'Valor inválido',
    email: value => {
      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return pattern.test(value) || 'Formato do e-mail inválido';
    }
  }
};

const getters = {
  apiHost: state => state.host,
  sqlSaida: state => state.sqlSaida,
  sqlItemSaida: state => state.sqlItemSaida,
  sqlProducao: state => state.sqlProducao,
  sqlItemProducao: state => state.sqlItemProducao,
  idEstoqueEntradaProducao: state => state.idEstoqueEntradaProducao,
  idColaborador: state => state.idColaborador,
  configuracoes: state => state.configuracoes,
  modeloColetaProducaoRequisicao: state => state.configuracoes.find(config => config.idConfig === 1).value,
  permiteBarrasRepetido: state => state.configuracoes.find(config => config.idConfig === 2).value,
  permiteQtdeDivergente: state => state.configuracoes.find(config => config.idConfig === 3).value,
  validaCodigoBarrasCodigoProduto: state => state.configuracoes.find(config => config.idConfig === 4).value,
  validaCodigoBarrasUnidadeProduto: state => state.configuracoes.find(config => config.idConfig === 5).value,
  corFundoAoLerCodigo: state => state.configLayout.find(config => config.idConfig === 1).value,
  rules: state => state.rules
};

const actions = {
  setHost({ commit }, host) {
    commit('SET_HOST', host);
  },
  setSqlSaida({ commit }, sqlSaida) {
    commit('SET_SQL_SAIDA', sqlSaida);
  },
  setSqlItemSaida({ commit }, sqlItemSaida) {
    commit('SET_SQL_ITEM_SAIDA', sqlItemSaida);
  },
  setSqlUnidades({ commit }, sqlUnidades) {
    commit('SET_SQL_UNIDADES', sqlUnidades);
  },
  setSqlProducao({ commit }, SqlProducao) {
    commit('SET_SQL_PRODUCAO', SqlProducao);
  },
  setSqlItemProducao({ commit }, SqlItemProducao) {
    commit('SET_SQL_ITEM_PRODUCAO', SqlItemProducao);
  },
  setIdEstoqueEntradaProducao({ commit }, IdEstoqueEntradaProducao) {
    commit('SET_ID_ESTOQUE_ENTRADA_PRODUCAO', IdEstoqueEntradaProducao);
  },
  setIdColaborador({ commit }, IdColaborador) {
    commit('SET_ID_COLABORADOR', IdColaborador);
  },
  loadConfiguracoes({ commit }) {
    commit('LOAD_CONFIGURACOES');
  },
  saveConfiguracoes({ commit }, obj) {
    commit('SAVE_CONFIGURACOES', obj);
  }
};

const mutations = {
  LOAD_CONFIGURACOES: state => {
    const configColetor = localStorage.getItem('configColetor');
    if (configColetor) {
      const {
        host,
        sqlSaida,
        sqlUnidades,
        sqlItemSaida,
        sqlProducao,
        sqlItemProducao,
        idEstoqueEntradaProducao,
        idColaborador,
        configuracoes = [],
        configLayout = []
      } = JSON.parse(configColetor);

      state.host = host;
      state.sqlSaida = sqlSaida;
      state.sqlUnidades = sqlUnidades;
      state.sqlItemSaida = sqlItemSaida;
      state.sqlProducao = sqlProducao;
      state.sqlItemProducao = sqlItemProducao;
      state.idEstoqueEntradaProducao = idEstoqueEntradaProducao;
      state.idColaborador = idColaborador;
      state.configuracoes.forEach(configState => {
        for (const configLocal of configuracoes) {
          if (configState.description == configLocal.description) {
            configState.value = configLocal.value;
          }
        }
      });
      state.configLayout.forEach(configState => {
        for (const configLocal of configLayout) {
          if (configState.description == configLocal.description) {
            configState.value = configLocal.value;
          }
        }
      });
    }
  },
  SAVE_CONFIGURACOES: (state, obj) => {
    state.host = obj.host;
    state.sqlSaida = obj.sqlSaida;
    state.sqlUnidades = obj.sqlUnidades;
    state.sqlItemSaida = obj.sqlItemSaida;
    state.sqlProducao = obj.sqlProducao;
    state.sqlItemProducao = obj.sqlItemProducao;
    state.idEstoqueEntradaProducao = obj.idEstoqueEntradaProducao;
    state.idColaborador = obj.idColaborador;
    state.configuracoes = obj.configuracoes;
    state.configLayout = obj.configLayout;
    localStorage.setItem('configColetor', JSON.stringify(obj));
  },
  SET_HOST: (state, host) => state.host = host,
  SET_SQL_SAIDA: (state, sqlSaida) => state.sqlSaida = sqlSaida,
  SET_SQL_ITEM_SAIDA: (state, sqlItemSaida) => state.sqlItemSaida = sqlItemSaida,
  SET_SQL_UNIDADES: (state, sqlUnidades) => state.sqlUnidades = sqlUnidades,
  SET_SQL_PRODUCAO: (state, sqlProducao) => state.sqlProducao = sqlProducao,
  SET_SQL_ITEM_PRODUCAO: (state, sqlItemProducao) => state.sqlItemProducao = sqlItemProducao,
  SET_ID_ESTOQUE_ENTRADA_PRODUCAO: (state, idEstoqueEntradaProducao) => state.idEstoqueEntradaProducao = idEstoqueEntradaProducao || '1',
  SET_ID_COLABORADOR: (state, idColaborador) => state.idColaborador = idColaborador || '1'
};

export default {
  state,
  getters,
  actions,
  mutations
}